import { defineMessages } from 'react-intl';

export default defineMessages({
  food: {
    id: 'app.shopReviews.food',
    defaultMessage: 'COMIDA: {food}',
  },
  service: {
    id: 'app.shopReviews.service',
    defaultMessage: 'SERVICIO: {service}',
  },
  speed: {
    id: 'app.shopReviews.speed',
    defaultMessage: 'VELOCIDAD: {speed}',
  },
});
